import React, { useState, useRef, useEffect } from 'react';
import { Box, Input, FormControl, Image, InputRightElement, FormLabel, InputGroup, useOutsideClick } from '@chakra-ui/react';
import 'react-day-picker/dist/style.css';
import { DayPicker } from 'react-day-picker';
import format from 'date-fns/format';
import { isValid, isAfter, isBefore } from 'date-fns';
import moment from 'moment';


const COLORS = {
  INPUT_FOCUS_DARK: "#384052",
  PRIMARY_WHITE: "#ffffff",
  BTN_DISABLE: "#f0f0f0",
  BTN_DISABLE_TEXT: "#a0a0a0",
};

const activeLabelStyles = {
  transform: "scale(0.85) translateY(-24px)",
  fontSize: "sm",
  color: COLORS.INPUT_FOCUS_DARK,
  opacity: "50%",
};

const inputStyles = {
  borderRadius: "0px",
  background: COLORS.PRIMARY_WHITE,
  boxShadow: "none",
  width: "100%",
  height: "48px",
  _disabled: {
    bg: COLORS.BTN_DISABLE,
    color: COLORS.BTN_DISABLE_TEXT,
    cursor: "not-allowed",
  },
  _hover: {
    borderRadius: "10px",
    border: `2px solid`,
    borderColor: COLORS.INPUT_FOCUS_DARK,
    outline: "none",
    bg: "none",
  },
  _focus: {
    borderRadius: "10px",
    border: "2px solid",
    borderColor: COLORS.INPUT_FOCUS_DARK,
    outline: "none",
  },
};

function DatePickerEDD({
    id,
    onDateChange, // This will now be the state setter function (e.g., setEDDDate)
    placeholderProp,
    defaultDate,
    value,
    clearValue = false,
    dateWidth = "100%",
    onChange,
    leftPos,
    calendarStlye,
    datePickerStyle,
    disableFutureDates,
    disablePastDates,
    disableDatePicker = false,
    minDate,
    maxDate,
    datePickerInputStyle,
    CUSTOM_DISABLE = false,
    patientDOB,
  }) {
    const [selected, setSelected] = useState(defaultDate ? moment(defaultDate, 'DD-MM-yyyy').toDate() : null);
    const [isDatePickerVisible, setDatePickerVisible] = useState(false);
    const outSideClick = useRef(null);
    const minDateFromDOB = patientDOB ? moment(patientDOB, 'Do MMMM, YYYY').toDate() : null;
  
    // Update selected date when value prop changes
    useEffect(() => {
      if (value) {
        setSelected(moment(value, 'DD-MM-yyyy').toDate());
      }
    }, [value]);
  
    const handleInputClick = () => {
      disableDatePicker ? setDatePickerVisible(false) : setDatePickerVisible(prev => !prev);
    };
  
    const handleDateSelect = (date) => {
      if (date) {
        setSelected(date);
        if (onDateChange) {
          // Call the state setter function with the formatted date
          onDateChange(moment(date).format('DD-MM-YYYY'));
        }
      }
      setDatePickerVisible(false);
    };
  
    const isLabelActive = selected != null;
  
    useOutsideClick({
      ref: outSideClick,
      handler: () => isDatePickerVisible && setDatePickerVisible(false),
    });
  
    const css = `
      .rdp-day_selected {
        background-color: #1F50C6;
      }
    `;
  
    const disableDates = (date) => {
      // Your existing disableDates logic
    };
  
    return (
      <>
        <style>{css}</style>
        <FormControl position="relative" width={dateWidth} ref={outSideClick} {...datePickerStyle}>
          <InputGroup borderRadius="0">
            <Input
              sx={{ ...inputStyles, ...datePickerInputStyle }}
              type="text"
              id={id}
              value={selected ? moment(selected).format('DD-MM-yyyy') : ''}
              onClick={handleInputClick}
              onChange={onChange}
              readOnly
              placeholder={!isLabelActive ? placeholderProp : ''}
              p={isLabelActive ? "12px 10px 0 10px" : "0px 10px 0 10px"}
              textOverflow="ellipsis"
              paddingRight="20px"
            />
            <InputRightElement
              h="100%"
              children={
                <Image
                  mr="8px"
                  cursor="pointer"
                  onClick={handleInputClick}
                  w="15px"
                  src="/assets/imgs/double-arrow.png"
                  alt=""
                />
              }
            />
          </InputGroup>
          <FormLabel
            sx={{
              ...activeLabelStyles,
              position: "absolute",
              top: "25px",
              pointerEvents: "none",
              opacity: isLabelActive ? 0.5 : 0,
              zIndex: isLabelActive ? 1 : -1,
              transition: "all 0.2s ease-out",
              left: "6px",
              ...leftPos,
            }}
          >
            {placeholderProp}
          </FormLabel>
          {isDatePickerVisible && (
            <Box position="absolute" borderRadius="0 0 15px 15px" zIndex="9999" bg="white" boxShadow="0px 10px 15px -3px rgba(0,0,0,0.1)" transform="scale(0.9)" right="-18px" top="32px" {...calendarStlye}>
              <DayPicker
                mode="single"
                fromYear={1901}
                toYear={2060}
                captionLayout="dropdown-buttons"
                selected={selected}
                onSelect={handleDateSelect}
                disabled={disableDates}
                defaultMonth={selected}
              />
            </Box>
          )}
        </FormControl>
      </>
    );
  }

export default DatePickerEDD;
